module.exports = __webpack_public_path__ + "img/y-122.5b8f0b22.png";